import { render, staticRenderFns } from "./WsInfoTags.vue?vue&type=template&id=40ae4034&"
import script from "./WsInfoTags.vue?vue&type=script&lang=js&"
export * from "./WsInfoTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports